export function getErrorMessage(error: unknown): string {
  if (!error) return "";

  if (typeof error === "string") return error;
  if (typeof error === "number" || typeof error === "boolean") return String(error);

  if (typeof error === "object") {
    const anyErr = error as any;

    const axiosData = anyErr?.response?.data;
    if (typeof axiosData === "string" && axiosData.trim()) return axiosData;
    if (typeof axiosData?.message === "string" && axiosData.message.trim()) {
      return axiosData.message;
    }
    if (typeof axiosData?.error === "string" && axiosData.error.trim()) {
      return axiosData.error;
    }

    if (typeof anyErr?.message === "string" && anyErr.message.trim()) {
      return anyErr.message;
    }

    try {
      return JSON.stringify(error);
    } catch {
      // ignore
    }
  }

  return String(error);
}
